module.exports = __webpack_public_path__ + "static/media/CallZa_Logo.972d9c13.png";